import { Suspense, useCallback, useContext, useEffect, useState } from "react";
import { LoaderContext } from "../../../../Services/Loader_Provider_Service/LoadingContext";
import { TostMsg } from "../../../../App";
import { getEmployeeList } from "../../EmployeeList/Service/employeeService";
import ComponentLoader from "../../../../Shared/Sidebar/ComponentLoader";

const TeamReportOrHierarchy = ({ employeeId, employee }) => {
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const toster = useContext(TostMsg);
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");
  const [hirechyData, setHirechyData] = useState([]);
  const { showLoading, hideLoading } = useContext(LoaderContext);
  const [reportingHirechy, setReportingHirechy] = useState([]);
  const defaultImage = "/images/placeholder_profile.png";
  const [teamHeader, setTeamHeader] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [reportManager, setReportManager] = useState([]);

  useEffect(() => {
    if (employeeId) {
      ReportOrHierarchy();
      GetMasterSystemAlertList("View_Manager_Team", 1);
    }
    reportingManager();
  }, [employeeId]);

  async function reportingManager() {
    var params1 = {
      OrganisationId: userDetails?.OrgId,
      LoggedInEmployeeId: employee[0]?.OverseerId,
      IsDirectReportOrHierarchy: 1,
      SearchText: "",
      FollowersOnly: 0,
      FollowingsOnly: 0,
      IsExEmployeesAlso: 0,
      pageNumber: 1,
      pageSize: 1000,
      EmployeeId: employee[0]?.OverseerId,
      IsSuggestedOnly: 0,
    };
    try {
      showLoading();
      let hierarchyList = await getEmployeeList(params1);
      setReportManager(hierarchyList.Data);
      hideLoading();
    } catch (error) {
      setIsLoading(false);
    }
  }

  const handleImageError = useCallback((event) => {
    event.target.src = defaultImage;
  }, []);

  async function ReportOrHierarchy(data) {
    let EmpId = 0;
    if (data?.Id) {
      setHirechyData((prev) => {
        const existsIndex = prev.findIndex((item) => item.EmpId === data.EmpId);
        if (existsIndex !== -1) {
          return prev.slice(0, existsIndex + 1);
        }
        return [...prev, data];
      });
      EmpId = data?.Id;
    } else if (employee[0]?.OverseerId) {
      setHirechyData((prevValues) => []);
      EmpId = employee[0]?.OverseerId;
    } else {
      setHirechyData((prevValues) => []);
      EmpId = employeeId;
    }
    var params1 = {
      OrganisationId: userDetails?.OrgId,
      LoggedInEmployeeId: userDetails?.EmpId,
      IsDirectReportOrHierarchy: 2,
      SearchText: "",
      FollowersOnly: 0,
      FollowingsOnly: 0,
      IsExEmployeesAlso: 0,
      pageNumber: 1,
      pageSize: 1000,
      EmployeeId: EmpId,
      IsSuggestedOnly: 0,
    };
    try {
      let employeesHierarchyList = await getEmployeeList(params1);
      setReportingHirechy(
        employeesHierarchyList.Data?.sort(
          (a, b) => b?.DirectReporteeCount - a?.DirectReporteeCount
        )
      );
      hideLoading();
      setIsLoading(false);
    } catch (error) {
      hideLoading();
      setIsLoading(false);
    }
  } 

  const GetMasterSystemAlertList = useCallback(async (message, type) => {
    SystemAlerts?.filter((msg) => {
      if (msg?.Name == message && type == 0) {
        toster.current.success(msg?.Desc);
      } else if (msg?.Name == message && type == 1) {
        setTeamHeader(msg?.Desc);
      }
    });
  }, []);

  return (
    <div className="documentdiv">
      <div className="">
        <div className="timeline-div">
          <h4 className="text-primary mb-3 sumh4 info-type-heading">
            Team
            <div class="ms-2 info-tooltip-area ">
              <div className="pf-img-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-info"
                  viewBox="0 0 16 16"
                >
                  <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0" />
                </svg>
              </div>
              <div class="info-tooltip-content info-area">
                <div class="purchase-tooltip-content">{teamHeader}</div>
              </div>
            </div>
          </h4>

          <div className="timeline">
            {employee[0]?.OverseerName ? (
              <div
                className="timeline-month"
                style={{ cursor: "pointer" }}
                onClick={() => ReportOrHierarchy(0)}
              >
                <img
                  src={employee[0]?.OverseerImage || defaultImage}
                  onError={handleImageError}
                />

                <p>{employee[0]?.OverseerName}</p>
                <p className="designation">
                  {" "}
                  {reportManager[0]?.CurrentDesignation}
                </p>
              </div>
            ) : (
              <div
                className="timeline-month"
                style={{ cursor: "pointer" }}
                onClick={() => ReportOrHierarchy()}
              >
                <img
                  src={employee[0]?.ProfileImage || defaultImage}
                  onError={handleImageError}
                />
                <div>
                  <p>{employee[0]?.FullName}</p>
                  <p className="designation">
                    {" "}
                    {employee[0]?.OverseerDesignation}
                  </p>
                </div>
              </div>
            )}

            {hirechyData?.map((item) => (
              <div
                className="timeline-month"
                style={{ cursor: "pointer" }}
                onClick={() => ReportOrHierarchy(item)}
              >
                {" "}
                <img
                  src={item?.ProfileImage || defaultImage}
                  onError={handleImageError}
                />
                <p>{item?.FullName}</p>
                <p className="designation"> {item?.CurrentDesignation}</p>
              </div>
            ))}
            <div className="timeline-section">
              {hirechyData && (
                <div className="timeline-date w-time">
                  <p className="mb-0">
                    Direct Reports - {reportingHirechy?.length}
                  </p>
                </div>
              )}
              {reportingHirechy?.length > 0 && (
                <div
                  className="row"
                  style={{
                    background: "white",
                    padding: "1rem 0",
                  }}
                >
                  {reportingHirechy?.map((report, index) => {
                    return (
                      <div key={index} className="divide-div">
                        <div
                          className="timeline-box"
                          style={{ cursor: "pointer" }}
                          onClick={() => ReportOrHierarchy(report)}
                        >
                          <div className="box-content">
                            <div class="info-tooltip-area">
                              {
                                <img
                                  src={report?.ProfileImage || defaultImage}
                                  onError={handleImageError}
                                />
                              }
                              <div class="info-tooltip-content">
                                <div class="purchase-tooltip-content">
                                  <div className="user-info">
                                    <div className="d-flex align-items-start">
                                      <img
                                        src={
                                          report?.ProfileImage || defaultImage
                                        }
                                        className="me-1"
                                        onError={handleImageError}
                                      />

                                      <div className="userdetail-tooltip">
                                        <strong>{report?.FullName}</strong>
                                        <span>
                                          {report?.CurrentDesignation}
                                        </span>

                                        {report?.DirectReporteeCount != 0 ? (
                                          <p>
                                            Member Count -{" "}
                                            <span className="count">
                                              {report?.DirectReporteeCount}
                                            </span>
                                          </p>
                                        ) : (
                                          ""
                                        )}
                                      </div>
                                    </div>

                                    <ul>
                                      {report?.UserName && (
                                        <li>
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="16"
                                            height="16"
                                            fill="currentColor"
                                            class="bi bi-envelope"
                                            viewBox="0 0 16 16"
                                          >
                                            <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1zm13 2.383-4.708 2.825L15 11.105zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741M1 11.105l4.708-2.897L1 5.383z" />
                                          </svg>{" "}
                                          <span>{report?.UserName}</span>
                                        </li>
                                      )}
                                      {report?.PhoneNumber && (
                                        <li>
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="16"
                                            height="16"
                                            fill="currentColor"
                                            class="bi bi-phone"
                                            viewBox="0 0 16 16"
                                          >
                                            <path d="M11 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zM5 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z" />
                                            <path d="M8 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2" />
                                          </svg>
                                          <span>{report?.PhoneNumber}</span>
                                        </li>
                                      )}
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div className="box-item">
                              <strong>{report?.FullName}</strong>
                              <span>{report?.CurrentDesignation}</span>
                              <div className="team-report-info ">
                                {report?.DirectReporteeCount != 0 ? (
                                  <p>
                                    <span className="img-team-report">
                                      <img src="/images/menu-icon/quick-action/emp/3.png" />
                                    </span>
                                    <span className="count">
                                      {report?.DirectReporteeCount}
                                    </span>
                                  </p>
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {isLoading ? (
        <Suspense>
          <ComponentLoader />
        </Suspense>
      ) : (
        ""
      )}
    </div>
  );
};

export default TeamReportOrHierarchy;
